import { models, kea, fa, resources, history } from "app/main/std";
import { observeResource } from "kea-resource";
import { columnas } from "./columns";

import React = require("react");
import { createSelector, createSelectorRx } from "keautils";
const resource = resources.origenesUsuarioApi;

type Entity = models.OrigenUsuarioApi;

interface Props {
    /**Id del usuario api de los origenes */
    idUsuarioApi: number;
}

/**Listado de los origenes de un usuarioApi */
export class OrigenUsuarioApiList extends React.PureComponent<Props>{
    modalManager = kea.createModalManager();

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar origen?", x.Clave)) {
            await resource.delete(x.IdRegistro);
        }
    }

    idUsuario = (props: Props) => props.idUsuarioApi;

    observable = createSelectorRx(this.idUsuario, idUsuario => observeResource(resource.query, idUsuario));


    onEdit = (x: Entity) => history.go(`/catalogos/UsuarioApi/origen/${this.props.idUsuarioApi}/${x.IdRegistro}`);
    onAgregar = () => history.go(`/catalogos/UsuarioApi/origen/${this.props.idUsuarioApi}/new`);


    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Origenes" size="h3">
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 items={this.observable(this.props)} columnas={cols} cookieKey="OrigenUsuarioApiListCookieKey" />
                {this.modalManager.component}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/origen/index.tsx